<template>
  <v-autocomplete
    v-model="type"
    :items="types"
    label="Distraction Type"
    @input="onInput"
  />
</template>

<script>
export default {
  name: 'DistractionTypeSelect',
  data: () => ({
    type: null,
    types: []
  }),
  props: {
    value: Number
  },
  watch: {
    value: function () {
      this.type = this.value
    }
  },
  mounted: function () {
    var _this = this
    this.axios.get('/distractions/types')
      .then(function (res) {
        for (var i in res.data) {
          var v = res.data[i]
          _this.types.push({ text: v.title, value: v.id })
        }
      })
      .catch(this.$root.apiErrorHandler())
  },
  methods: {
    // Propagate our selection so it works with a parent v-model
    onInput: function (ev) {
      this.$emit('input', this.type)
    }
  }
}
</script>
